import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import { Flex, Box } from 'legion-ui';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`The Flex component is identical to the Box component, but with display: flex set. If you need to alter the display property, use the Box component instead.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Flex } from 'legion-ui';
`}</code></pre>
    <div className="divi" />
    <h2>{`Variant`}</h2>
    <p>{`Legion have only one variant of flex`}</p>
    <h3><strong parentName="h3">{`Basic`}</strong></h3>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <Flex mdxType="Flex">
    <Box p={2} bg="primary500" color="white" sx={{
          flexGrow: 1
        }} mdxType="Box">
      Flex
    </Box>
    <Box p={2} bg="success500" color="white" mdxType="Box">
      Box
    </Box>
  </Flex>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Flex>
  <Box p={2} bg="primary500" color="white" sx={{ flexGrow: 1 }}>
    Flex
  </Box>
  <Box p={2} bg="success500" color="white">
    Box
  </Box>
</Flex>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      